<template>
  <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8.48535" y="1.92886" width="10" height="10" transform="rotate(45 8.48535 1.92886)" stroke="white"
      stroke-width="2" />
    <rect x="14.4561" y="1.92886" width="10" height="10" transform="rotate(45 14.4561 1.92886)" stroke="white"
      stroke-width="2" />
  </svg>
</template>
  
<script>
export default {
  name: "ListBullet",
};
</script>